const config = [
  { propName: 'searchTerm', reducerName: 'searchTerm' },
  { propName: 'filters', reducerName: 'filters' },
  { propName: 'page', reducerName: 'page' },
  { propName: 'sort', reducerName: 'sort' },
  { propName: 'currentStage', reducerName: 'currentStage' },
  { propName: 'getStagesCount', reducerName: 'getStagesCount' },
  { propName: 'candidateList', reducerName: 'candidateList' },
  { propName: 'createContact', reducerName: 'createContact' },
  { propName: 'kanbanList', reducerName: 'kanbanList' },
  { propName: 'rejectedCount', reducerName: 'rejectedCount' },
  { propName: 'reloadConfig', reducerName: 'reloadConfig' },
  { propName: 'currentApplication', reducerName: 'currentApplication' },
  {
    propName: 'currentApplicationActivities',
    reducerName: 'currentApplicationActivities',
  },
  {
    propName: 'currentApplicationActivitiesPage',
    reducerName: 'currentApplicationActivitiesPage',
  },
  { propName: 'currentJobActivities', reducerName: 'currentJobActivities' },
  {
    propName: 'currentJobActivitiesPage',
    reducerName: 'currentJobActivitiesPage',
  },
  {
    propName: 'filterWithValues',
    reducerName: 'filterWithValues',
  },
];

export const getAtsJobDetails = (state) => {
  const atsJob = {};

  config.forEach(({ propName, reducerName }) => {
    atsJob[propName] = state?.atsJobDetails?.[reducerName];
  });

  return atsJob;
};

export const getAtsJobScorecardParams = (state) => {
  return state?.atsJobDetails?.scorecardParams;
};
